import FileDownloadList from './FileDownloadList';

export default FileDownloadList;
